import { useState, useEffect } from 'react'
import { useGetOrganizationBrandingPublicQuery } from '../services/orgsApi'

export const useOrganizationBranding = (skip = false) => {
  const {
    data: brandingBlob,
    isLoading,
    error,
    refetch,
  } = useGetOrganizationBrandingPublicQuery(undefined, {
    skip,
  })
  const [logoUrl, setLogoUrl] = useState<string | undefined>()

  useEffect(() => {
    if (brandingBlob) {
      const url = URL.createObjectURL(brandingBlob)
      setLogoUrl(url)

      // Cleanup function to revoke the object URL when component unmounts or brandingBlob changes
      return () => {
        URL.revokeObjectURL(url)
      }
    } else {
      setLogoUrl(undefined)
    }
  }, [brandingBlob])

  return {
    logoUrl,
    isLoading,
    error,
    refetch,
  }
}
